import './cart_item.css';
import { EditIcon } from "../../assets/icons/EditIcon";
import { SpinnerLoader } from "../SpinnerLoader/SpinnerLoader";
import { useEffect, useState } from 'react';
import { useMenu } from '../../context/MenuContext';
import { ItemQty } from '../ItemQty/ItemQty';
import { useCart } from '../../context/CartContext';
import { useServer } from '../../context/ServerContext';
import { cartEndpoints } from '../../env';
import { useSingleProduct } from '../../context/SingleProductContext';

export const CartItem = ({item}) => {
    //HOOKS
    const { sectionPool } = useMenu();
    const {
        cartLoading,
        setCartLoading,
        getCartToken,
        loadCart,
        setCart
    } = useCart();
    const { postRequest } = useServer();
    const { openProductUpdate } = useSingleProduct();

    //STATES
    const [itemLoading, setItemLoading] = useState(false);
    const [section, setSection] = useState(null);
    const [qty, setQty] = useState(1);
    
    //FUNCTIONS
    const openEdit = () => {
        openProductUpdate(item);
    }

    const handleQtyChange = (newQty) => {
        setItemLoading(true);
        setCartLoading(true);

        let data = {
            cart_token: getCartToken(),
            item_id: item.id,
            qty: newQty,
        }

        postRequest(cartEndpoints.update_item, data, (res) => {
            setItemLoading(false);
            setCartLoading(false);

            if (res[0])
            {
                res = res[1];
                if (res.success)
                {
                    setCart(res.cart);
                }
                else
                {
                    loadCart();
                }
            }
            else
            {
                loadCart();
            }
        });
    }

    const handleDelete = () => {
        setItemLoading(true);
        setCartLoading(true);

        let data = {
            cart_token: getCartToken(),
            items: [item.id],
        }

        postRequest(cartEndpoints.delete_items, data, (res) => {
            setItemLoading(false);
            setCartLoading(false);

            if (res[0])
            {
                res = res[1];
                if (res.success)
                {
                    setCart(res.cart);
                }
                else
                {
                    loadCart();
                }
            }
            else
            {
                loadCart();
            }
        });
    }

    //EFFECTS
    useEffect(() => {
        setQty(item.qty);
        setSection(sectionPool.find(section => section.id === item.product.menu_section_id) || null);
    }, [item]);

    return (
        <div className='cart_item'>
            <div className='info'>
                <h2>
                    {item.product.name} / { section && section.name }
                </h2>
                <div className='edit_container' disabled={itemLoading} onClick={openEdit}>
                    <EditIcon />
                    <p>
                        Edit
                    </p>
                </div>
            </div>
            <div className='values_container'>
                <div className='price'>
                    <div className='loader active'>
                        {
                            itemLoading && (
                                <SpinnerLoader />
                            )
                        }
                    </div>
                    <span>
                        ${item.subtotal / 100}
                    </span>
                </div>
                <div className='qty_container'>
                    <ItemQty qty={qty} setQty={setQty} onChange={handleQtyChange} disabled={cartLoading} onDelete={handleDelete} />
                </div>
            </div>
        </div> 
    );
}